import { render, staticRenderFns } from "./pharmaceutical.vue?vue&type=template&id=5449aa9c&scoped=true&"
import script from "./pharmaceutical.vue?vue&type=script&lang=js&"
export * from "./pharmaceutical.vue?vue&type=script&lang=js&"
import style0 from "./pharmaceutical.vue?vue&type=style&index=0&id=5449aa9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449aa9c",
  null
  
)

export default component.exports